import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#00ff00',
      light: '#33ff33',
      dark: '#00cc00',
    },
    secondary: {
      main: '#ff00ff',
      light: '#ff33ff',
      dark: '#cc00cc',
    },
    background: {
      default: '#000000',
      paper: '#111111',
    },
    text: {
      primary: '#00ff00',
      secondary: '#00ffff',
    },
  },
  typography: {
    fontFamily: '"Rajdhani", "Inter", "Helvetica", "Arial", sans-serif',
    h1: {
      fontFamily: '"Orbitron", "sans-serif"',
      fontWeight: 700,
      color: '#00ff00',
      textShadow: '0 0 10px rgba(0, 255, 0, 0.5)',
    },
    h2: {
      fontFamily: '"Orbitron", "sans-serif"',
      fontWeight: 600,
      color: '#00ff00',
      textShadow: '0 0 8px rgba(0, 255, 0, 0.5)',
    },
    h3: {
      fontFamily: '"Orbitron", "sans-serif"',
      fontWeight: 600,
      color: '#00ff00',
      textShadow: '0 0 6px rgba(0, 255, 0, 0.5)',
    },
    h4: {
      fontFamily: '"Orbitron", "sans-serif"',
      color: '#00ff00',
      textShadow: '0 0 4px rgba(0, 255, 0, 0.5)',
    },
    h5: {
      fontFamily: '"Orbitron", "sans-serif"',
      color: '#00ff00',
      textShadow: '0 0 4px rgba(0, 255, 0, 0.5)',
    },
    h6: {
      fontFamily: '"Orbitron", "sans-serif"',
      color: '#00ff00',
      textShadow: '0 0 4px rgba(0, 255, 0, 0.5)',
    },
    button: {
      textTransform: 'none',
      fontFamily: '"Rajdhani", "sans-serif"',
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          backgroundColor: '#111111',
          border: '1px solid #333333',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#111111',
          backgroundImage: 'none',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          '&.MuiTypography-body1, &.MuiTypography-body2': {
            color: '#ffffff',
          },
        },
      },
    },
  },
});